<template>
    <div class="container container-main-noticies">
        <div class="row row__primary-block">
            <div class="col-12 col-lg-6 col-variation-3">
                <div class="row" v-if="Object.keys(main).length">
                    <div class="col-12 col-lg-12">
                        <SuperLink 
                            class="main-noticies__top main-noticies__top--first" 
                            :href="main.link" 
                            target="_self">
                            <p class="noticies__title noticies__title--blue">
                                <strong>{{main.title}}</strong>
                            </p>
                            <p class="noticies__subtitle">{{main.subtitle}}</p>
                        </SuperLink>
                    </div>
                </div>
                <div class="row" v-if="related">
                    <div class="col-12">
                        <template v-for="r in related">
                            <SuperLink
                                :href="r.link" 
                                :key="r.id" 
                                class="main-noticies__top main-noticies__top--second" 
                                target="_self">
                                <p class="noticies__title noticies__title--blue">
                                    <strong>• {{r.title || r.link.title}}</strong>
                                </p>
                            </SuperLink>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-6 row__primary-block-3">
                <div class="row" v-if="big">
                    <div class="col-6" v-for="noticia in cbig" :key="noticia.id">
                        <SuperLink :href="noticia.link" target="_self" class="noticies-item">
                            <div class="noticies-item--image">
                                <img v-if="noticia.image" :src="utils.image(noticia.image, 256, 304)" alt="">
                                <img v-else-if="noticia.link.image" :src="utils.image(noticia.link.image, 256, 304)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label">
                                    <strong v-if="noticia.hat">{{noticia.hat}}</strong>
                                    <strong v-else-if="noticia && noticia.link && noticia.link.editorial">{{noticia.link.editorial.title}}</strong>
                                </p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                            </div>
                        </SuperLink>
                    </div>
                    <div class="col-6" v-if="vivo">
                        <Tabs>
                            <SuperLink v-if="simple && simple.link" :href="simple.link" target="_self" class="noticies-item noticies-item__tab --header-5">
                                <p class="noticies__label">
                                    <strong v-if="simple.hat">{{simple.hat}}</strong>
                                    <strong v-else-if="simple && simple.link && simple.link.editorial">{{simple.link.editorial.title}}</strong>
                                </p>
                                <p class="noticies__title noticies__title--blue noticies__title--small"><strong>{{simple.title}}</strong></p>
                            </SuperLink>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>

        <div class="row row__secondary-block row__secondary-block--variation-3" v-if="small">
            <div class="col-12 col-md-4 col-lg-2" v-for="sm in small" :key="sm.id">
                <SmallItem :item="sm" />
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
import SmallItem from '@/components/home/header/Small'
import Tabs from '@/components/home/header/Tabs'

import SuperLink from '@/components/SuperLink'

export default {
    name: 'Header03',
    props:{
        'main': Object, 
        'small': Array, 
        'simple': Object, 
        'big': Array,
        'related': Array,
        'vivo': Boolean,
    },
    components: {SmallItem, Tabs, SuperLink},

    data(){
        return {
            utils:utils
        }
    },
    computed:{
        cbig: function () {
            if (this.vivo) {
                return this.big.slice(0,1)
            }
            return this.big
        },
    }
}
</script>